import React from "react"
import { Text } from "@convertkit/slate"
import { VideoEmbed } from "../custom-elements/video-embed"

export const videoEmbeds = () => {
  return {
    commands: {
      embedVideo: (editor, { href, embedHtml, ...attributes }) => {
        editor.insertBlock({
          type: "video-embed",
          data: { href, embedHtml, ...attributes },
          nodes: [Text.create("")]
        })
      }
    },
    schema: {
      blocks: {
        "video-embed": {
          // Lift `video-embed` up to the root document.
          parent: { object: "document" },
          isVoid: true,
          normalize: (editor, error) => {
            if (error.code === "parent_object_invalid") {
              const ancestor = editor.value.document.getParent(error.parent.key)
              const index = ancestor.nodes.indexOf(error.parent)
              editor.moveNodeByKey(error.node.key, ancestor.key, index)
            }
          }
        }
      }
    },
    renderNode(props, editor, next) {
      const { attributes, node } = props

      if (node.type === "video-embed") {
        return (
          <VideoEmbed {...node.data.toJS()} {...attributes} editing={true} />
        )
      } else {
        return next()
      }
    }
  }
}
